import React, { useState } from 'react';

import EmailProps from '../proptypes/email';
import EditEmailModal from './profile/EditEmailModal';

const UpdateEmailButton = ({ email }) => {
  const [isEditEmailModalOpen, setIsEditEmailModalOpen] = useState(false);

  if (!email.isVerified) {
    return null;
  }

  return (
    <>
      <idme-button
        variant="tertiary"
        text="Edit"
        size="small"
        onClick={() => setIsEditEmailModalOpen(true)}
      />

      {isEditEmailModalOpen && (
        <EditEmailModal
          email={email}
          closeModal={() => setIsEditEmailModalOpen(false)}
          isOpen={isEditEmailModalOpen}
        />
      )}
    </>
  );
};

UpdateEmailButton.propTypes = {
  email: EmailProps.isRequired,
};

export default UpdateEmailButton;
